export const RoutesPath = {
    chemistry: '/',
    chemistryHistory: '/history',
    doc: '/doc',
}